function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "15",
  height: "21",
  viewBox: "0 0 15 21",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("rect", {
  width: "15",
  height: "21",
  rx: "3",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("rect", {
  x: "2",
  y: "2",
  width: "11",
  height: "17",
  rx: "1",
  fill: "#6B1BE3"
}), /*#__PURE__*/React.createElement("rect", {
  x: "5",
  y: "15",
  width: "5",
  height: "2",
  rx: "1",
  fill: "#fff"
})));